import React from 'react';

export default function License() {
  return (
    <div className="max-w-3xl mx-auto py-12 px-6">
      <h1 className="text-2xl font-semibold text-center mb-6">MIT License</h1>
      <div className="overflow-x-auto">
        <pre className="bg-white dark:bg-gray-800 p-6 rounded-md shadow-lg text-gray-900 dark:text-gray-100 whitespace-pre-wrap break-words">
          <div className="text-justify mb-6">
            MIT License Copyright (c) 2025 Northern Robotics Laboratory
          </div>

          <div className="text-justify mb-6">
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions:
          </div>

          <div className="text-justify mb-6">
            The above copyright notice and this permission notice shall be
            included in all copies or substantial portions of the Software.
          </div>
          <div className="text-justify">
            THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
            EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </div>
        </pre>
      </div>
    </div>
  );
}
